var naviItem = $('.process_chart a');
var boxItem = $('.process');
scrollingNow(naviItem, boxItem, 130);

function scrollingNow (naviItem, boxItem, scOffset) {
  // ナビとエリアとその数を取得
  var naviNum = naviItem.length;
  var boxNum = boxItem.length;
  // いくつ増えてもいいように配列を用意
  var naviItemElm = new Array();
  var boxItemElm = new Array();
  var itemKey = new Array();
  var boxKey = new Array();
  var distance = new Array();
  var height = new Array();
  var endPoint = new Array();

  // スクロールするたびに以下が起動
  $(window).on('load scroll', function () {
    // スクロール量を取得
    var scrollTopDistance = $(window).scrollTop();
    // ナビの数だけ以下を繰り返す
    for (var a = 0; a < naviNum; a++) {
      naviItemElm[a] = naviItem.eq(a);
      boxItemElm[a] = boxItem.eq(a);
      // hrefから#の文字を除く
      itemKey[a] = naviItemElm[a].attr('href').replace(/#/g, '');
      boxKey[a] = boxItemElm[a].attr('id');
      // scOffsetで反応する位置を調整
      distance[a] = boxItemElm[a].offset().top - scOffset;
      height[a] = boxItemElm[a].outerHeight();
      endPoint[a] = distance[a] + height[a];
				 // もし、hrefとidが同じで、現在スクロールがボックスの開始地点より大きく、終了地点より小さい場合、class="now"を付与する。
      if (itemKey[a] == boxKey[a] && scrollTopDistance > distance[a] && scrollTopDistance < endPoint[a]) {
        naviItem.eq(a).addClass('cur');
      } else if (scrollTopDistance < distance[a] || scrollTopDistance > endPoint[a]) {
        naviItem.eq(a).removeClass('cur');
      }
    }
  });
}
